const values = [
  {
    icon: 'ri-building-2-line',
    title: '商業思維先行',
    desc: '我們不只是設計師，更是你的商業空間顧問。從品牌定位、消費動線到坪效配置，每個決策都以商業目標為核心。',
  },
  {
    icon: 'ri-palette-line',
    title: '空間美學落地',
    desc: '精準把握品牌調性，將美感設計轉化為實際可施工的空間方案，確保設計圖與完工效果高度一致。',
  },
  {
    icon: 'ri-tools-line',
    title: '工程整合執行',
    desc: '從設計到施工一條龍整合，嚴格控管工期、預算與品質，讓業主省心、省力、不踩雷。',
  },
  {
    icon: 'ri-line-chart-line',
    title: '品牌資產思維',
    desc: '空間是品牌最持久的投資。我們協助你打造具有識別度、能吸引目標客群、提升品牌價值的商業空間。',
  },
];

export default function ValueSection() {
  return (
    <section className="py-24 md:py-32 bg-[#f4f2ef]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Our Approach</p>
            <h2
              className="font-bold text-[#1a1a1a] leading-[1.35]"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              我們不只是做設計<br />
              <span className="font-display font-light italic" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)' }}>
                我們協助品牌創造更有價值的商業空間
              </span>
            </h2>
          </div>
          <p
            className="text-[#5a5a5a] max-w-md leading-relaxed"
            style={{ fontSize: '1.1875rem' }}
          >
            心旅商研整合「品牌策略 × 空間設計 × 工程落地」，
            讓商業空間成為你最有效率的品牌行銷工具。
          </p>
        </div>

        {/* Value Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => (
            <div
              key={i}
              className="bg-[#fafaf8] rounded-2xl p-8 flex flex-col gap-5 hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center border border-[#e2ddd8] rounded-xl">
                <i className={`${v.icon} text-[#b8956a] text-xl`}></i>
              </div>
              <div>
                <h3
                  className="font-semibold text-[#1a1a1a] mb-3 leading-[1.45]"
                  style={{ fontSize: '1.1875rem' }}
                >
                  {v.title}
                </h3>
                <p className="text-[#5a5a5a] text-sm leading-relaxed">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
